<template>
    <main ref="careers" class="main careers">
        <section class="header-image header-image-careers"></section>

        <div v-for="(opening, index) in openings" :key="opening.title">
            <section :class="getSectionClass(index)">
                <div class="container">
                    <div class="row">
                        <h2 class="section-heading col-12 col-md-3" :class="getSectionHeadingClass(index)">
                            {{ opening.title }}</h2>
                        <div class="col-12 col-md-9" v-html="opening.text">
                        </div>
                    </div>
                </div>
            </section>
            <section v-if="displayCareersImage(index)" class="careers-image"
                v-bind:style="{ 'background-image': 'url(\'./images/large/' + getImage(index) + '.jpg\'' }"></section>
        </div>

        <Policy ref="policy" type="policy" :visible="policyVisible" v-on:togglePolicy="$emit('togglePolicy', $event)">
        </Policy>
        <Policy ref="shipRecycling" type="shipRecycling" :visible="shipRecyclingVisible"
            v-on:toggleShipRecycling="$emit('toggleShipRecycling', $event)"></Policy>
    </main>
</template>

<script>
import Policy from "./main/Policy.vue";

export default {
    name: "Careers",
    props: ["policyVisible", "shipRecyclingVisible"],
    components: {
        Policy
    },
    data() {
        return {
            images: ["3", "2"]
        }
    },
    computed: {
        openings() {
            return this.$store.getters.orderedCareers;
        }
    },
    mounted() {
        let element = this.$el.querySelector(".section");

        window.scrollTo(0, element.offsetTop);
    },
    methods: {
        getSectionClass(index) {
            let result = "section careers-section";

            index++;

            if (index % 4 === 0) {
                result += " section-gray";
            } else if (index % 2 === 0) {
                result += " section-blue";
            }

            return result;
        },
        getSectionHeadingClass(index) {
            index++;

            if (index % 4 !== 0 && index % 2 === 0) {
                return "section-heading-white";
            } else {
                return "";
            }
        },
        displayCareersImage(index) {
            let openingsLength = this.openings.length,
                imagesLength = this.images.length,
                relation = Math.floor(openingsLength / imagesLength);

            if (index + 1 === openingsLength) {
                return false;
            } else if (relation <= 1) {
                return true;
            } else if ((index + 1) % relation === 0) {
                return true;
            } else {
                return false;
            }
        },
        getImage(index) {
            let openingsLength = this.openings.length,
                imagesLength = this.images.length,
                relation = Math.floor(openingsLength / imagesLength);

            if (relation <= 1) {
                return this.images[index];
            } else {
                return this.images[(index + 1) / relation - 1];
            }
        }
    }
}
</script>
